import { jsx as _jsx } from "react/jsx-runtime";
export const SourgumThirtyYdDimensions2 = (props) => {
    const src = new URL('./dumpster-30.png', import.meta.url).toString();
    return _jsx("img", { ...props, src: src, alt: "Thirty Yard Dimensions" });
};
//# sourceMappingURL=thirty-yard-dimensions-sourgum2.js.map